import { acceptSpecialOffer } from './acceptSpecialOffer';
import { checkAndRecordShoppingPopup } from './checkAndRecordShoppingPopup';
import { checkIsVoip } from './checkIsVoip';
import { checkRetentionLinkByPhoneNumber } from './checkRetentionLinkByPhoneNumber';
import { clearUserOfFraudSuspicion } from './clearUserOfFraudSuspicion';
import { createCaller } from './createCaller';
import { createCallerAddress } from './createCallerAddress';
import { deleteBulkCallerAddresses } from './deleteBulkCallerAddresses';
import { deleteCaller } from './deleteCaller';
import { deleteCallerAddress } from './deleteCallerAddress';
import { enableAutoReload } from './enableAutoReload';
import { endSubscription } from './endSubscription';
import { fetchCallerActiveHours } from './fetchCallerActiveHours';
import { fetchCallerDateEvents } from './fetchCallerDateEvents';
import { fetchApprovedCallerAddresses } from './fetchApprovedCallerAddresses';
import { fetchCallerByCallerId } from './fetchCallerByCallerId';
import { fetchCallerTimeZone } from './fetchCallerTimeZone';
import { fetchCustomerAddress } from './fetchCustomerAddress';
import { fetchCustomerInfo } from './fetchCustomerInfo';
import { fetchCustomers } from './fetchCustomers';
import { fetchTotalOrderInfo } from './fetchTotalOrderInfo';
import { findCallerPhoneNumberByExternalPartnerCallerId } from './findCallerPhoneNumberByExternalPartnerCallerId';
import { findCallerPhoneNumberByPreAuthorizationNumber } from './findCallerPhoneNumberByPreAuthorizationNumber';
import { generateRetentionLink } from './generateRetentionLink';
import { getGeneratedLink } from './getGeneratedLink';
import { getCallerLovedOneIdName } from './getCallerLovedOneIdName';
import { getServiceFee } from './getServiceFee';
import { getVisitorId } from './getVisitorId';
import { getVisitorInformation } from './getVisitorInformation';
import { isChargedDeposit } from './isChargedDeposit';
import { payForAnyUnpaidServices } from './payForAnyUnpaidServices';
import { saveGourmetPopupResponse } from './saveGourmetPopupResponse';
import { saveGroceryPopupResponse } from './saveGroceryPopupResponse';
import { saveShoppingPopupResponse } from './saveShoppingPopupResponse';
import { sendAccountDeactivationRequestReminder } from './sendAccountDeactivationRequestReminder';
import { sendCreditCardFormLinkEmail } from './sendCreditCardFormLinkEmail';
import { sendCreditCardFormLinkSms } from './sendCreditCardFormLinkSms';
import { sendFreeTrialReminder } from './sendFreeTrialReminder';
import { sendRetentionLinkEmail, sendRetentionLinkSms } from './sendRetentionLink';
import { sendWelcomeTextSmsToCaller } from './sendWelcomeTextSmsToCaller';
import { updateCaller } from './updateCaller';
import { updateCallerActiveHours } from './updateCallerActiveHours';
import { updateCustomerAddress } from './updateCustomerAddress';

export const callerService = {
  acceptSpecialOffer,
  checkAndRecordShoppingPopup,
  checkIsVoip,
  checkRetentionLinkByPhoneNumber,
  clearUserOfFraudSuspicion,
  createCaller,
  createCallerAddress,
  deleteBulkCallerAddresses,
  deleteCaller,
  deleteCallerAddress,
  enableAutoReload,
  endSubscription,
  fetchCallerActiveHours,
  fetchCallerDateEvents,
  fetchApprovedCallerAddresses,
  fetchCallerByCallerId,
  fetchCustomerAddress,
  fetchCallerTimeZone,
  fetchCustomerInfo,
  fetchCustomers,
  fetchTotalOrderInfo,
  findCallerPhoneNumberByExternalPartnerCallerId,
  findCallerPhoneNumberByPreAuthorizationNumber,
  generateRetentionLink,
  getGeneratedLink,
  getCallerLovedOneIdName,
  getServiceFee,
  getVisitorId,
  getVisitorInformation,
  isChargedDeposit,
  payForAnyUnpaidServices,
  saveGourmetPopupResponse,
  saveGroceryPopupResponse,
  saveShoppingPopupResponse,
  sendAccountDeactivationRequestReminder,
  sendCreditCardFormLinkEmail,
  sendCreditCardFormLinkSms,
  sendFreeTrialReminder,
  sendRetentionLinkEmail,
  sendRetentionLinkSms,
  sendWelcomeTextSmsToCaller,
  updateCaller,
  updateCallerActiveHours,
  updateCustomerAddress,
};
